import "@/translations/i18n"
import { assetUrl } from '@/utils/asset-url'
import { useState,useEffect } from 'react'
import { useTranslation } from "react-i18next"
import usePage from '@/hooks/use-page/index';
import Portal from '@/components/Portal/index';
import Input from '@/components/Input/index';
import { ReactComponent as IconEye } from '@/assets/svgs/eye.svg'
import useLicenseKey from '@/hooks/use-license-keys/index';
import Toast2 from '@/components/Toast2'
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";

const LicenseKey = () => {

	/*=================================================
		General
	/================================================*/

	const { t } = useTranslation();
	const [pageTitle] = useState(t("licenseKey"))
	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Configuration',
				link: ``
			},
		]
	})
	const [customMask, setCustomMask] = useState(true)

	const [licenseKey, setLicenseKey] = useState([])

	/*=================================================
		Error Modal
	/================================================*/
	const [error, setError] = useState()
	function handleError(){
		setError()
	}

	/*=================================================
		API
	/================================================*/

	const { getOne, error:errorLicenseKey } = useLicenseKey()

	useEffect(() => {
		getOne().then(value=>{
			setLicenseKey(value)
		}).catch(value=>{
			setError(value.error.message)
		})
	}, [])

	useEffect(()=>{
		setError(errorLicenseKey)
	}, [errorLicenseKey])

	return (
		<>

			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
			</div>

			<hr />

			<div className="overview">
				<div className="overview__content ">
					<div className="license-keys-field__wrapper">
						<div className="license-keys__label">
							Host
						</div>

						<div className="license-keys__value_box">
							<Input disabled className="license-keys__value" value={licenseKey?.host || ""} />
						</div>

					</div>

					<div className="license-keys-field__wrapper">
						<div className="license-keys__label">
							Environment
						</div>

						<div className="license-keys__value_box">
							<Input disabled className="license-keys__value" value={licenseKey?.mode || ""}/>
						</div>
					</div>

					<div className="license-keys-field__wrapper">
						<div className="license-keys__label">
							Organization
						</div>
						<div className="profile">
						<div>
							<div className="licence-keys__org_img" style={{ backgroundImage: `url(${licenseKey?.org?.iconUrl})` }}></div>
						</div>
						</div>
						<div className="licence-keys__section-right">
							<div className="licence-keys__org-name">{licenseKey?.org?.name}</div>
						</div>
					</div>

					<div className="license-keys-field__wrapper">
						<div className="license-keys__label">
							System
						</div>

						<div className="license-keys__value_box">
							<Input disabled className="license-keys__value" value={licenseKey?.sys?.systemName || ""}/>
						</div>
					</div>

					<div className="license-keys-field__wrapper">
						<div className="license-keys__label">
							License Key
						</div>

						<div className="license-keys__value_box licence-keys__section-left">
							<Input disabled className="license-keys__value" value={licenseKey?.key || ""} type={customMask ? 'password' : 'text'}/>

						</div>

						<span className="link licence-keys__section-bottom" onClick={() => setCustomMask(!customMask)}>
							<IconEye fill="#8c8c8c" />
						</span>
					</div>

					<hr />

					{/* <div className="licence-keys__contact">
						if you have any queries, <span className="link link--color">Contact Us</span>
					</div> */}
				</div>
			</div>
			<Toast2 show={error} errorMessage={error} close={()=>{handleError()}} />
		</>
	)
}

export default LicenseKey;


